import { z } from "zod";
import { asListId, asNoteId, asUserId, ok } from "@pack-it-up/shared";
import { firestoreTimestamp, parseDto, toTimestamp } from "./common.js";
export const NoteDtoSchema = z.object({
    id: z.string(),
    // The owning list (trip or template) — same denormalised key as items/todos.
    listId: z.string(),
    body: z.string(),
    links: z.array(z.object({ url: z.string(), label: z.string().optional() })),
    tags: z.array(z.string()).optional(), // T29 — user-defined tags; absent, never []
    authorId: z.string(),
    // createdAt is a server timestamp; optional so legacy docs without it still parse.
    createdAt: firestoreTimestamp().optional(),
    order: z.string(),
});
export const toDomainNote = (raw) => {
    const p = parseDto(NoteDtoSchema, raw, "Note");
    if (!p.ok)
        return p;
    const d = p.value;
    return ok({
        id: asNoteId(d.id),
        listId: asListId(d.listId),
        body: d.body,
        links: d.links.map((l) => ({ url: l.url, ...(l.label !== undefined ? { label: l.label } : {}) })),
        ...(d.tags !== undefined ? { tags: d.tags } : {}),
        authorId: asUserId(d.authorId),
        createdAt: d.createdAt !== undefined ? d.createdAt.getTime() : 0,
        order: d.order,
    });
};
// The repo overrides `createdAt` with `serverTimestamp()` for new creates; updates
// only write body/links so the stored server timestamp is always preserved.
export const toNoteDto = (n) => ({
    id: n.id,
    listId: n.listId,
    body: n.body,
    links: n.links.map((l) => ({ url: l.url, ...(l.label !== undefined ? { label: l.label } : {}) })),
    ...(n.tags !== undefined ? { tags: n.tags } : {}),
    authorId: n.authorId,
    createdAt: toTimestamp(new Date(n.createdAt)),
    order: n.order,
});
//# sourceMappingURL=note.mapper.js.map